/** Size limits shared by the API (which enforces them) and the site (which explains them). */
export const LIMITS = {
  slug: { min: 3, max: 80 },
  title: { min: 3, max: 140 },
  summary: { min: 10, max: 300 },
  bodyMd: { min: 1, max: 60_000 },
  updateBody: { min: 1, max: 500 },
  linkLabel: { min: 1, max: 80 },
  contactName: { min: 1, max: 100 },
  contactMessage: { min: 10, max: 4_000 },
  pageSize: { min: 1, max: 50, fallback: 10 },
} as const;
